import type { App } from 'vue'
import { setupPermissionDirective } from './permission/hasPermi'
import { setupPowerCheckDirective } from './permission/hasPower'

import { setupDisableEnterDirective } from './ez/v-disable-enter'
import { setupIsDevelopmentDirective } from './permission/isDevelopment'

/**
 * 導出指令：v-xxx
 * @methods hasPermi 按鈕權限，用法: v-hasPermi
 */
export const setupPermission = (app: App<Element>) => {
  setupPermissionDirective(app)
  setupPowerCheckDirective(app)
  setupIsDevelopmentDirective(app)

  setupDisableEnterDirective(app)
}
